import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadWhatsMenu: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source={"WHATSMENU"} title={"Importar catálogo WhatsMenu"}
  instructions={"Copie a URL do cardápio digital da sua loja no WhatsMenu."}
  placeholder={"https://www.whatsmenu.com.br/sua-loja"} />;

export default UploadWhatsMenu;
